import React from "react";
import ReactDom from "react-dom";

import MultiMapChildApp from "./MultiMapChildApp.jsx";

export default function renderMultiMapChild() {
  document.querySelectorAll(".js-multi-map-child").forEach((mount) => {
    const dataModel = JSON.parse(mount.dataset.model);
    const dataDictionary = JSON.parse(mount.dataset.dictionary);

    ReactDom.render(
      <MultiMapChildApp {...dataModel} dictionary={dataDictionary} />,
      mount,
    );
  });

  document.querySelectorAll(".js-multi-map-child-ee").forEach((el) => {
    const elMapArea = el.querySelector(".js-multi-map-child-map");
    const elDot = el.querySelector(".js-multi-map-child-pin");
    const elX = el.querySelector(".js-multi-map-child-xcoord");
    const elY = el.querySelector(".js-multi-map-child-ycoord");
    const copyButtonX = el.querySelector(".js-coord-clipboard-x");
    const copyButtonY = el.querySelector(".js-coord-clipboard-y");

    const handleDrop = (xCoord, yCoord) => {
      const rect = elMapArea.getBoundingClientRect();
      const x = parseInt(((xCoord - rect.x) / rect.width) * 100); //x position within the element.
      const y = parseInt(((yCoord - rect.y) / rect.height) * 100); //y position within the element.
      elDot.style.left = `${x}%`;
      elDot.style.top = `${y}%`;
      elX.value = x;
      elY.value = y;
    };

    // need this but not sure why
    el.addEventListener("dragover", (event) => {
      event.preventDefault();
      event.stopPropagation();
    });

    // need this but not sure why
    el.addEventListener("dragleave", (event) => {
      event.preventDefault();
      event.stopPropagation();
    });

    el.addEventListener("drop", (event) => {
      event.preventDefault();
      event.stopPropagation();
      // store destination mouse position
      handleDrop(event.clientX, event.clientY);
    });

    elX.addEventListener("keyup", (e) => {
      const value = elX.value;
      elDot.style.left = value.length > 0 ? `${value}%` : "0%";
    });

    elY.addEventListener("keyup", (e) => {
      const value = elY.value;
      elDot.style.top = value.length > 0 ? `${value}%` : "0%";
    });

    elX.addEventListener("change", (e) => {
      const value = elX.value;
      elDot.style.left = value.length > 0 ? `${value}%` : "0%";
    });

    elY.addEventListener("change", (e) => {
      const value = elY.value;
      elDot.style.top = value.length > 0 ? `${value}%` : "0%";
    });

    const copyToClipboard = (coord) => {
      const value = coord === "x" ? elX.value : elY.value;

      navigator.clipboard.writeText(value).catch((err) => {
        console.error("Failed to copy to clipboard:", err);
      });
    };

    copyButtonX.addEventListener("click", () => copyToClipboard("x"));
    copyButtonY.addEventListener("click", () => copyToClipboard("y"));
  });
}
